import { DEFAULT_COUNT_DOWN_TIME } from "@/hooks/usePhotoCapture";

interface CaptureStatusProps {
  capturedImagesCount: number;
  isCapturing: boolean;
}

export function CaptureStatus({ capturedImagesCount, isCapturing }: CaptureStatusProps) {
  if (isCapturing) {
    return null; // Don't show status during capture
  }

  return (
    <>
      <div className="text-center mt-8">
        <p className="font-family-reenie text-[24px]">
          Timer set for every <span className="text-vintage-red font-bold"> {DEFAULT_COUNT_DOWN_TIME} </span> seconds
        </p>
      </div>

      {/* Show captured images count */}
      {capturedImagesCount > 0 && (
        <div className="mt-8 text-center">
          <p className="text-vintage-red font-bold">
            {capturedImagesCount} photos captured successfully!
          </p>
        </div>
      )}
    </>
  );
}
